export const getCovidSelfAssessment = state => state.covidSelfAssessment;
